// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"22651ebd","317":"e68dc5ec","569":"c4b5334a","586":"a775f071","604":"85d500a9"}[chunkId] + ".chunk.js";
};